export const NAME = 'enterprisecard';

export const REQUEST_ENTERPRISE_CARD_PAY = 'REQUEST_ENTERPRISE_CARD_PAY';
export const SUCCESS_ENTERPRISE_CARD_PAY = 'SUCCESS_ENTERPRISE_CARD_PAY';
export const FAILURE_ENTERPRISE_CARD_PAY = 'FAILURE_ENTERPRISE_CARD_PAY';

export const REQUEST_ENTERPRISE_CARD_DETAILS = 'REQUEST_ENTERPRISE_CARD_DETAILS';
export const SUCCESS_ENTERPRISE_CARD_DETAILS = 'SUCCESS_ENTERPRISE_CARD_DETAILS';
export const FAILURE_ENTERPRISE_CARD_DETAILS = 'FAILURE_ENTERPRISE_CARD_DETAILS';

// marqueur d'URL de la page de confirmation
export const ENTERPRISE_CARD_PAYMENT_PARAM = 'ecard';



// WEBPACK FOOTER //
// ./src/services/enterprisecard/constants.js